import * as z from 'zod';

import { DrawId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';

export const DrawInput = z.object({
  amount: z.number(),
  date: zodJSPlainDate,
  comment: z.string().optional(),
  isReversal: z.boolean().optional(),
  transactionId: DrawId.optional(), // if this is a reversal, this is the id of the original draw
  externalId: z.string().optional(), // External ID given by lender via API. Used for idempotency.
});
export type DrawInput = z.infer<typeof DrawInput>;

export const Draw = DrawInput.extend({
  id: DrawId,
  createdDate: zodJSInstantDate.optional(),
});
export type Draw = z.infer<typeof Draw>;
